import React from 'react';
import classnames from 'classnames';
import { Box, Typography, formatPrice } from '@lucid/lego';
import { formatString } from '../../../../utils/tools';
import styles from './Price.module.scss';
import { useStore } from '../../../../store/store';

type PriceProps = {
  label: string;
  value: number;
  theme: 'dark' | 'light';
  isBold?: boolean;
  isNegative?: boolean;
  skipFormatting?: boolean;
};

/**
 * Price component for displaying pricing breakdown
 * @component
 */
const Price: React.FC<PriceProps> = ({
  label,
  value,
  theme,
  isBold = false,
  isNegative = false,
  skipFormatting = false,
}) => {
  const formattedLabel = skipFormatting ? label : formatString(label);
  const locale = useStore((state) => state.locale);
  const formattedPrice = formatPrice(Math.abs(value), { locale });

  // Show "—" for zero or falsy values
  const displayPrice = value === 0 || !value ? '—' : `${isNegative ? '-' : ''}${formattedPrice}`;

  return (
    <Box className={styles.priceRow}>
      <Typography
        className={classnames({ [styles.bold]: isBold })}
        variant="body"
        size={isBold ? 'medium' : 'small'}
        theme={theme}
      >
        {formattedLabel}
      </Typography>
      <Typography
        className={classnames({ [styles.bold]: isBold })}
        variant="body"
        size={isBold ? 'medium' : 'small'}
        theme={theme}
      >
        {displayPrice}
      </Typography>
    </Box>
  );
};

Price.displayName = 'Price';

export default Price;
